import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './profile-list-item.component.scss';
import * as $ from 'jquery';
import axios from 'axios';
var ProfileListItem = /** @class */ (function (_super) {
    tslib_1.__extends(ProfileListItem, _super);
    function ProfileListItem(element) {
        return _super.call(this, element) || this;
    }
    ProfileListItem.prototype.init = function () {
        this.playButton = this.element.querySelector('.js-video-play');
        this.closeButton = this.element.querySelector('.js-video-close');
        this.playerContainer = this.element.querySelector('.video-carousel-item__container');
        this.playerContent = this.element.querySelector('.video-carousel-item__playercontent');
        this.playerTimeContainer = this.element.querySelector('.video-carousel-item__time-placeholder');
        if (this.element.querySelector('.ot-video-containingBlock')) {
            this.player = this.playerContainer.querySelector('.ot-video-containingBlock');
        }
        this.video = this.element.querySelector('video');
        this.isExternal = false;
    };
    ProfileListItem.prototype.bindEvents = function () {
        var _this = this;
        if (this.playButton) {
            this.playButton.addEventListener('click', function (event) { return _this.showVideo(event); });
        }
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.hideVideo(event); });
        }
        // this.renderTime();
    };
    ProfileListItem.prototype.showVideo = function (event) {
        var element = event.currentTarget;
        if (element.closest('.deals-list')) {
            event.preventDefault;
            this.hideActiveVideo(event);
            this.playerContainer.classList.add('video-carousel-item__container--playing');
            if (event.currentTarget.hasAttribute('data-youtube-id')) {
                this.isExternal = true;
                var videoExternal = event.currentTarget;
                var getVideo = videoExternal.getAttribute('data-youtube-id');
                this.createIframePlayer(getVideo);
                this.analyticsService.dtmVideoTrackerAutoSpot();
            }
            else if (event.currentTarget.hasAttribute('data-vidavee-id')) {
                this.isExternal = true;
                var videoExternal = event.currentTarget;
                var getVideo = videoExternal.getAttribute('data-vidavee-id');
                this.createIframePlayer(getVideo, true);
            }
            else {
                this.player.style.height = "100%";
                this.video.player.play();
            }
        }
    };
    ProfileListItem.prototype.hideVideo = function (event) {
        event.preventDefault;
        var removeIframe = this.playerContent.querySelector('iframe');
        this.playerContainer.classList.remove('video-carousel-item__container--playing');
        if (removeIframe) {
            this.playerContent.removeChild(removeIframe);
        }
        else {
            this.video.player.pause();
        }
    };
    ProfileListItem.prototype.hideActiveVideo = function (event) {
        var selectedVideo = event.target;
        if (!selectedVideo.classList.contains('video-carousel-item__container--playing')) {
            var videoContainers = Array.from(document.querySelectorAll('.video-carousel-item__container--playing'));
            videoContainers.map(function (itemContainer) {
                itemContainer.classList.remove('video-carousel-item__container--playing');
                var iframeExistence = itemContainer.querySelector('iframe');
                if (iframeExistence) {
                    var iframeChildren = $(itemContainer).find('iframe');
                    iframeChildren.remove();
                }
                else {
                    var videoChildren = itemContainer.querySelector('video');
                    var playerChildren = itemContainer.querySelector('.ot-video-containingBlock');
                    videoChildren.pause();
                }
            });
        }
    };
    ProfileListItem.prototype.createIframePlayer = function (url, vidavee) {
        if (vidavee === void 0) { vidavee = false; }
        if (vidavee) {
            var externalUrl = '/vidaveePlayer.jsp?remoteId=';
            externalUrl += url;
            var createIframe = document.createElement('iframe');
            createIframe.id = 'video__external';
            createIframe.src = externalUrl;
            createIframe.classList.add('video__iframe');
            this.playerContent.appendChild(createIframe);
        }
        else {
            var externalUrl = 'https://www.youtube.com/embed/';
            externalUrl += url;
            externalUrl += '?rel=0&amp;showinfo=0&autoplay=1&enablejsapi=1';
            var createIframe = document.createElement('iframe');
            createIframe.id = 'video__external';
            createIframe.src = externalUrl;
            createIframe.classList.add('video__iframe');
            this.playerContent.appendChild(createIframe);
        }
    };
    ProfileListItem.prototype.renderTime = function () {
        if (this.playButton.hasAttribute('data-youtube-id')) {
            var videoTimePlaceholder_1 = this.playerTimeContainer;
            var getVideo = this.playButton.getAttribute('data-youtube-id');
            axios.get('https://www.googleapis.com/youtube/v3/videos?part=contentDetails&id=' + getVideo + '&key=AIzaSyBcaoVc-sCwi_7txKMV9BEUhDf4yrcq384', { responseType: 'json' }).then(function (response) {
                var object = response.data.items[0].contentDetails.duration;
                var array = object.match(/(\d+)(?=[MHS])/ig) || [];
                var formatted = array.map(function (item) {
                    if (item.length < 2)
                        return '0' + item;
                    return item;
                }).join(':');
                if (formatted) {
                    videoTimePlaceholder_1.innerHTML = formatted;
                }
                else {
                    videoTimePlaceholder_1.innerHTML = '00:00:00';
                }
            }).catch(function (response) {
                console.log(response);
            });
        }
    };
    return ProfileListItem;
}(Base));
export { ProfileListItem };



//////////////////
// WEBPACK FOOTER
// ./components/profile-list-item/profile-list-item.component.ts
// module id = 462
// module chunks = 0